// extracted by mini-css-extract-plugin
export default {"root":"under_maintenance_root__WvKFd","contain":"under_maintenance_contain__ZvLBj","logo":"under_maintenance_logo__4n350","text":"under_maintenance_text__DByBD"};